import { obtenerProductosConPrecio } from "../infraestructure/supabase/productosPrecio.repository.js";

export async function obtenerProductosPrecioUseCase() {
  try {
    const productos = await obtenerProductosConPrecio();

    return {
      success: true,
      data: productos || []
    };

  } catch (error) {
    return {
      success: false,
      error: "[application layer productos] Error al obtener: " + error.message
    };
  }
}